<div
	class="modal fade"
	id="authModal"
	tabindex="-1"
	aria-labelledby="authModalLabel"
	aria-hidden="true"
	data-bs-backdrop="static"
>
	<div class="modal-dialog modal-lg shadow">
		<div class="modal-content">
			<div class="modal-body">
				<div class="button-content">
					<button
						type="button"
						class="btn-close"
						data-bs-dismiss="modal"
						(click)="closeModal()"
						aria-label="Close"
					></button>
				</div>
				@if (!recuperaPassword) {
					<div class="row w-100 rounded">
						<div
							style="display: flex; align-items: center"
							class="col-md-6 col-sm-12 login-logo"
						>
							<img
								src="image/logo-homaiLogin.png"
								alt="HomAI Logo"
								class="img-fluid"
								style="width: 80% !important; margin-left: 9%"
							/>
						</div>
						<div class="col-md-6">
							<h3 class="text-center">Benvenuto in HomAI!</h3>
							<div class="switch-login-register">
								<button
									class="btn"
									[ngClass]="{ active: isLoginForm }"
									id="login-tab"
									(click)="showLogin()"
								>
									Login
								</button>
								<button
									class="btn"
									[ngClass]="{ active: !isLoginForm }"
									id="register-tab"
									(click)="showRegister()"
								>
									Registrati
								</button>
							</div>
							<!-- FORM DI LOGIN -->
							@if (isLoginForm) {
								<div id="login-form">
									<p style="margin-top: 10px; margin-bottom: 20px">
										Inserisci le tue credenziali per sfruttare la potenza dell'intelligenza artificiale nella ricerca e gestione dei tuoi immobili.
									</p>
									<form
										[formGroup]="loginForm"
										(ngSubmit)="onLoginSubmit()"
									>
										<div class="mb-3">
											<label
												for="username"
												class="form-label"
												>Nome utente</label
											>
											<input
												type="text"
												class="form-control"
												id="username"
												placeholder="Inserisci il tuo nome utente"
												formControlName="username"
												[ngClass]="{ 'is-invalid': loginForm.get('username')?.invalid && loginForm.get('username')?.touched }"
											/>
											@if (loginForm.get('username')?.invalid && loginForm.get('username')?.touched) {
												<div
													class="invalid-feedback"
													style="margin-left: 13px"
												>
													Il nome utente è obbligatorio.
												</div>
											}
										</div>
										<div class="mb-3">
											<label
												for="password"
												class="form-label"
												>Password</label
											>
											<div class="input-group">
												<input
													type="password"
													class="form-control"
													id="password"
													placeholder="Inserisci la tua password"
													formControlName="password"
													[ngClass]="{ 'is-invalid': loginForm.controls['password'].invalid && loginForm.controls['password'].touched }"
												/>
												<span
													style="cursor: pointer"
													[ngClass]="{
														'input-group-text toggle-password': true,
														invalidInput: loginForm.controls['password'].invalid && loginForm.controls['password'].touched,
													}"
													(click)="togglePassword('password')"
												>
													<i class="bi bi-eye-slash"></i>
												</span>
												@if (loginForm.controls['password'].invalid && loginForm.controls['password'].touched) {
													<div
														class="invalid-feedback"
														style="margin-left: 13px"
													>
														La password è obbligatoria
													</div>
												}
											</div>
										</div>
										<div
											class="d-flex justify-content-between"
											style="flex-wrap: wrap"
										>
											<div>
												<input
													type="checkbox"
													id="remember-me"
													formControlName="rememberMe"
												/>
												<label
													style="margin-left: 4px"
													for="remember-me"
													>Ricordami</label
												>
											</div>
											<div>
												<a
													style="cursor: pointer"
													(click)="recuperaPasswords(true)"
													>Password dimenticata?</a
												>
											</div>
										</div>
										<button
											[disabled]="loginForm.invalid"
											type="submit"
											class="btn btn-primary btn-center-rounded mt-3"
										>
											Accedi qua
										</button>
									</form>
									@if (errors && errors.errorMessage && errors.errorMessage.length > 0) {
										<div
											class="alert alert-danger"
											role="alert"
											style="margin-top: 10px"
										>
											<strong>ERRORE:</strong> {{ errors.errorMessage }}
										</div>
									}
								</div>
								<!-- FORM DI REGISTRAZIONE -->
							} @else {
								<div id="register-form">
									<p style="margin-top: 10px">Registrati per iniziare a utilizzare HomAI.</p>
									<form
										[formGroup]="registerForm"
										(ngSubmit)="onRegisterSubmit()"
									>
										<div class="mb-3">
											<label
												for="reg-username"
												class="form-label"
												>Nome utente</label
											>
											<input
												type="text"
												class="form-control"
												id="reg-username"
												placeholder="Inserisci il tuo nome utente"
												formControlName="username"
												[ngClass]="{ 'is-invalid': registerForm.get('username')?.invalid && registerForm.get('username')?.touched }"
											/>
											@if (
												registerForm.get('username')?.invalid &&
												registerForm.get('username')?.touched &&
												!registerForm.get('username')?.hasError('noEmailAllowed')
											) {
												<div
													class="invalid-feedback"
													style="margin-left: 13px"
												>
													Il nome utente è obbligatorio.
												</div>
											}
											@if (registerForm.get('username')?.hasError('noEmailAllowed') && registerForm.get('username')?.touched) {
												<div
													class="invalid-feedback"
													style="margin-left: 13px"
												>
													Il nome utente non può essere una mail.
												</div>
											}
										</div>
										<div class="mb-3">
											<label
												for="reg-email"
												class="form-label"
												>Email</label
											>
											<input
												type="email"
												class="form-control"
												id="reg-email"
												placeholder="Inserisci la tua email"
												formControlName="email"
												[ngClass]="{ 'is-invalid': registerForm.get('email')?.invalid && registerForm.get('email')?.touched }"
											/>
											@if (registerForm.get('email')?.invalid && registerForm.get('email')?.touched) {
												<div
													class="invalid-feedback"
													style="margin-left: 13px"
												>
													La email e è obbligatoria.
												</div>
											}
										</div>
										<div class="mb-3">
											<label
												for="password"
												class="form-label"
												>Password</label
											>
											<div class="input-group">
												<input
													type="password"
													class="form-control"
													id="reg-password"
													placeholder="Crea una password"
													formControlName="password"
													[ngClass]="{ 'is-invalid': passwordRegisterControl.invalid && passwordRegisterControl.touched }"
												/>
												<span
													[ngClass]="{
														'input-group-text toggle-password': true,
														invalidInput: passwordRegisterControl.invalid && passwordRegisterControl.touched,
													}"
													style="cursor: pointer"
													(click)="togglePassword('reg-password')"
												>
													<i class="bi bi-eye-slash"></i>
												</span>
												@if (passwordRegisterControl.invalid && passwordRegisterControl.touched && passwordRegisterControl.hasError('required')) {
													<div
														class="invalid-feedback"
														style="margin-left: 13px"
													>
														La password e è obbligatoria.
													</div>
												}
											</div>
										</div>
										@if (passwordRegisterControl.hasError('passwordNotStrong') && passwordRegisterControl.touched) {
											<div>
												<p class="text-danger">
													La password deve contenere almeno 8 caratteri, includere almeno una lettera maiuscola, una lettera minuscola e un carattere speciale.
												</p>
											</div>
										}
										<button
											[disabled]="registerForm.invalid"
											type="submit"
											class="btn btn-primary btn-center-rounded mt-3"
										>
											Registrati
										</button>
									</form>
									@if (errors && errors.errorMessage && errors.errorMessage.length > 0) {
										<div
											class="alert alert-danger"
											role="alert"
											style="margin-top: 10px"
										>
											<strong>ERRORE:</strong> {{ errors.errorMessage }}
										</div>
									}
									@if (registerSuccesful) {
										<div
											class="alert alert alert-success"
											role="alert"
											style="margin-top: 10px"
										>
											Grazie per esserti registrato! Controlla la tua <strong>email</strong> per confermare l'account e iniziare subito
										</div>
									}
								</div>
							}
						</div>
					</div>
					<!-- FORM RECUPERA PASSWORD -->
				} @else {
					<div class="row">
						<div class="col-md-6 col-sm-12 login-logo center-center">
							<img
								src="image/logo-homaiLogin.png"
								alt="HomAI Logo"
								class="img-fluid"
								style="height: 300px"
							/>
						</div>
						<div class="col-md-6 center-center">
							<div id="login-form">
								<h3 class="text-center">Recupero Password</h3>
								<p class="text-center">Inserisci la tua email per ricevere le istruzioni di recupero.</p>
								<form [formGroup]="lostPassword">
									<div class="mb-3">
										<label
											for="email"
											class="form-label"
											>Email</label
										>
										<input
											type="email"
											class="form-control"
											id="emaillost"
											placeholder="Inserisci la tua email"
											formControlName="email"
											required
										/>
										@if (lostPassword.get('email')?.invalid && lostPassword.get('email')?.touched) {
											<div
												class="invalid-feedback"
												style="margin-left: 13px"
											>
												La email e è obbligatoria.
											</div>
										}
									</div>
									<button
										[disabled]="lostPassword.invalid"
										type="submit"
										class="btn btn-primary btn-center-rounded mt-3"
										(click)="lostPasswordSubmit()"
									>
										Invia istruzioni
									</button>
									<div class="text-center mt-3">
										<a
											style="cursor: pointer"
											(click)="recuperaPasswords(false)"
											>Torna al login</a
										>
									</div>
								</form>
								@if (errors && errors.errorMessage && errors.errorMessage.length > 0) {
									<div
										class="alert alert-danger"
										role="alert"
										style="margin-top: 10px"
									>
										<strong>ERRORE:</strong> {{ errors.errorMessage }}
									</div>
								} @else if(infoSuccess) {
									<div
										class="alert alert-success"
										role="alert"
										style="margin-top: 10px"
									>
										<strong>INFO:</strong> Abbiamo inviato una nuova passsword alla tua Email.
									</div>
								}
							</div>
						</div>
					</div>
				}
			</div>
		</div>
	</div>
</div>
